module.exports = __webpack_public_path__ + "img/stats.9d3dd15e.png";